<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">
              WPO Status Page
            </h4>
          </div>
          <div class="card-body">
            <div class="loader" v-if="loading"></div>
            <table v-else class="table table-striped table-bordered">
              <thead>
              <tr>
                <th>Service</th>
                <th class="text-center">Status</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="row in allServices" :key="row.id">
                <td>
                  {{ row.value }}
                </td>

                <td width="25%" class="text-center">
                  <span v-if="row.success">
                    <i class="fa fa-check-circle text-success fs-24" style="font-size:24px"></i>
                  </span><span v-else>
                    <i class="fa fa-times-circle text-danger fs-24" style="font-size:24px"></i>
                  </span>
                </td>
              </tr>
              <template v-if="!loading && allServices.length === 0">
                <tr>
                  <td class="col-md-10 text-center text-danger mb-3 font-weight-bold" colspan="4">No Data Exists!</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import axios from "axios";
export default {
  name: "serviceStatus",
  data() {
    return {
      loading: false,
      allServices: [
        {key: 'mainBackendService', value: 'Main Backend Service', success: false, path: 'alerts/health', axios: this.$http},
        {key: 'reportMicroService', value: 'Report Micro Service', success: false, path: 'reports/health', axios: this.$reportService},
        {key: 'reminderMicroService', value: 'Reminder Micro Service', success: false, path: 'schedular/health', axios: this.$reminderService},
        {key: 'monitorMicroService', value: 'Monitor Micro Service', success: false, path: 'webhook/health', axios: this.$monitorService},
      ],
    }
  },
  mounted() {
    this.checkServicesStatus()
  },
  methods: {
    async checkServicesStatus() {
      try {
        this.loading = true;
        for (const service of this.allServices) {
          try {
            service.axios.post(service.path, {
              grant_type: "token",
            });
            service.success = true
          } catch (e) {
            service.success = false
          }
        }
        //   const response  = await this.$http.post("alerts/health", {
        //     grant_type: "token",
        //   });
        //   console.log(response)
        //   if(response.data.success) {
        //     const obj = this.allServices.find(el => el.key === 'mainBackendService');
        //     if(obj) {
        //       obj.success = true;
        //     }
        //   }
        //   const reportServiceResponse = await this.$reportService.post('/reports/health', {});
        //   console.log(reportServiceResponse)
        //   if(response.data.success) {
        //     const obj = this.allServices.find(el => el.key === 'reportMicroService');
        //     if(obj) {
        //       obj.success = true;
        //     }
        //   }
        // const monitorServiceResponse = await this.$monitorService.post('/webhook/health', {});
        //   console.log(monitorServiceResponse)
        //   if(response.data.success) {
        //     const obj = this.allServices.find(el => el.key === 'monitorMicroService');
        //     if(obj) {
        //       obj.success = true;
        //     }
        //   }
        //   const reminderServiceResponse = await this.$reminderService.post('/schedular/health', {});
        //   console.log(reminderServiceResponse)
        //   if(response.data.success) {
        //     const obj = this.allServices.find(el => el.key === 'reminderMicroService');
        //     if(obj) {
        //       obj.success = true;
        //     }
        //   }
      } catch (e) {
        console.log('error from main backend service health api', e.toString())
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style scoped>

</style>
